'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { CartDrawerProps } from './CartDrawer.types';

/**
 * Controlled side drawer for the header cart: focus is trapped while open,
 * Escape and the overlay close it, and focus returns to the trigger.
 */
export const CartDrawer = ({
  open,
  children,
  microcopy,
  onOpenChange,
  onCloseAutoFocus,
  className = '',
}: CartDrawerProps) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-overlay" />
      <Dialog.Content
        data-test="cart-drawer"
        aria-describedby={undefined}
        onCloseAutoFocus={onCloseAutoFocus}
        className={c(
          'fixed right-0 top-0 z-50 flex h-full w-full max-w-md flex-col bg-white shadow-card',
          'data-[state=open]:animate-slideIn',
          className
        )}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-grey-200 px-6 py-4">
          <Dialog.Title className="text-md font-semibold text-grey-900">
            {microcopy.title}
          </Dialog.Title>
          <Dialog.Close
            aria-label={microcopy.close}
            className="focus-outline flex h-11 w-11 items-center justify-center rounded-full text-grey-900 transition-colors hover:bg-grey-100"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </Dialog.Close>
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          {children}
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
